// extracted by mini-css-extract-plugin
export default {"PageContainer":"PageContainer_PageContainer__1uyjr","breakout":"PageContainer_breakout__6r-Fj","full":"PageContainer_full__Nv4V-","content":"PageContainer_content__b9Uby"};